import api from './api';

export const leaveService = {
  applyLeave: async (data) => {
    const response = await api.post('/leaves', data);
    return response.data;
  },

  getMyLeaves: async () => {
    const response = await api.get('/leaves/my-leaves');
    return response.data;
  },

  getAllLeaves: async (params) => {
    const response = await api.get('/leaves', { params });
    return response.data;
  },

  approveLeave: async (id, notes) => {
    const response = await api.put(`/leaves/${id}/approve`, { notes });
    return response.data;
  },

  rejectLeave: async (id, notes) => {
    const response = await api.put(`/leaves/${id}/reject`, { notes });
    return response.data;
  }
};
